<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Media Asset Picker</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickCancel"
                >
                    Cancel
                </v-btn>

                <v-btn
                    dark
                    text
                    @click="onClickSelect"
                >
                    Select
                </v-btn>

            </v-toolbar-items>
        </v-toolbar>

        <v-card-text
            style="padding-top: 15px"
        >

            <m-media-asset-search
                :organization_id="$rc.$state.getOrganizationId()"
                :content_type="content_type"
                select
                ref="asset-search"
            />

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            last_dialog_guard: null,
            content_type: null,
        }
    },

    methods: {

        showDialog(content_type)
        {
            this.content_type = content_type;
            this.dialog = true;
            this.last_dialog_guard = this.$router.dialog_guard;
            this.$router.dialog_guard = this.dialogGuard;
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = this.last_dialog_guard;

            // Reset them in case the dialog is used again...
            this.$refs['asset-search'].selected_assets = [];
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.closeDialog();
                return;
            }
        
            this.closeDialog();
            next(false);
        },
        
        onClickCancel()
        {
            this.closeDialog();
        },

        onClickSelect()
        {
            let selected = _.cloneDeep(this.$refs['asset-search'].getSelectedAssets());

            this.closeDialog();
            
            this.$emit('select', selected);
        },

    },
}
</script>

<style lang="scss" scoped>
</style>